import { NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'link-download',
    template: `

  <div class="flex flex-col justify-between mt-2" *ngIf="model.stato_id == 'compilazione'">

        <a class="ml-2" target="_blank" href="{{props.link}}">
        <div class="flex items-center">
            <span class="text-base uppercase font-semibold leading-5">{{props.label}}</span>
        </div>

        <div class="flex flex-row-reverse items-center">
        <mat-icon [svgIcon]="'feather:download'"></mat-icon>
        </div>
        </a>

    </div>

  `,
    standalone: true,
    imports: [FormlyModule, MatIconModule, NgIf]
})
export class LinkDownload extends FieldWrapper{


}
